import Image, { type ImageProps } from 'next/image';
import { cn } from '@/lib/cn';

type BrandIconProps = Omit<ImageProps, 'src' | 'alt' | 'unoptimized'> & {
  alt?: string;
};

/** Keep the square brand mark subtly rounded at every rendered size. */
export function BrandIcon({ alt = '', className, ...props }: BrandIconProps) {
  return (
    <Image
      {...props}
      src="/icon.png"
      alt={alt}
      unoptimized
      className={cn('rounded-[12%] object-contain', className)}
    />
  );
}
